import React, { FC } from 'react';

import { TEXTS } from 'application/pages/BillingPage/renderer/texts';
import CommonUtils from 'application/utils/CommonUtils';

import { DiscountValueType } from 'domain/api/graphql/generated';

import useDiscountViewModel from './useDiscountViewModel';

import styles from './index.module.scss';

const Discount: FC = () => {
  const { discount, nextBillingPriceAmount } = useDiscountViewModel();

  return (
    <div className={styles.discount}>
      {discount && discount.valueType === DiscountValueType.Percent && (
        <div className={styles.discountPercent}>{TEXTS.BILLING_LICENSES_DISCOUNT(discount.value)}</div>
      )}

      {discount && discount.valueType === DiscountValueType.Amount && (
        <span className={styles.discountValue}>
          {TEXTS.BILLING_LICENSES_AMOUNT(CommonUtils.numberWithSeparation(nextBillingPriceAmount!))}
        </span>
      )}
    </div>
  );
};

export default React.memo(Discount);
